import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import Loading from "../../../../components/loading";
import "./styles/analiseInfo.css";

export function AnaliseInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllAnaliseRiscoById(id, config).then(
                    (res) => {
                        setData(res);
                    }
                );
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    return (
        <div>
            <div className="container-analise">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Análise de risco da atividade</h1>
                </div>
                {isLoading ? (
                    <Loading isLoading={isLoading} />
                ) : (
                    data.map((check, i) => {
                        return (
                            <main className="datagrid-container-analise">
                                <div className="table-content-analise">
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Hora</th>
                                                <th>Atividade</th>
                                                <th>Empresa</th>
                                                <th>Local</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>
                                                {check.dt_inspecao
                                                    ? formatDate(
                                                          check.dt_inspecao
                                                      )
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.hora
                                                    ? check.hora
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.atividade
                                                    ? check.atividade
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.nm_empresa
                                                    ? check.nm_empresa
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.local
                                                    ? check.local
                                                    : "Não informado"}
                                            </td>
                                        </tbody>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Executante 1</th>
                                                <th>Executante 2</th>
                                                <th>Executante 3</th>
                                                <th>Medidas de controle</th>
                                                <th>
                                                    Atividade não rotineira?
                                                </th>
                                                <th>Observações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>{check.nm_exec1}</td>
                                            <td>
                                                {check.nm_exec2
                                                    ? check.nm_exec2
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.nm_exec3
                                                    ? check.nm_exec3
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.mediaControle
                                                    ? check.mediaControle
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.atividadeRotineira[0]
                                                    ? check
                                                          .atividadeRotineira[0]
                                                    : "Não informado"}
                                            </td>
                                            <td>
                                                {check.ds_observacoes
                                                    ? check.ds_observacoes
                                                    : "Não informado"}
                                            </td>
                                        </tbody>
                                    </div>
                                </div>
                            </main>
                        );
                    })
                )};
            </div>
        </div>
    );
}
